import { render, staticRenderFns } from "./GroupOfAccreditationRequirements.vue?vue&type=template&id=08454ce5&scoped=true"
import script from "./GroupOfAccreditationRequirements.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationRequirements.vue?vue&type=script&lang=js"
import style0 from "./GroupOfAccreditationRequirements.vue?vue&type=style&index=0&id=08454ce5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08454ce5",
  null
  
)

export default component.exports